import { useActivation } from '@context/MobileOne';
import { NavigationPageTitle, ButtonPrimary, ScrollToTop } from '@core/index';
import AppPageContentWrapper from '@part/AppPageContentWrapper';
import { appButtonType, appIconsPath } from '@utils/globalConstant';
import { tA11y } from '@utils/a11y/a11yHelpers';
import './Step8.scss';

export function PDFDownload() {
  const { setStep8SubStep, setShowActivationHeader } = useActivation();

  // Const
  const headerTextContent = tA11y('ek_reg_legal_txt1');
  const subHeader1Content = tA11y('ek_reg_legal_hdl2');
  const subHeader1TextContent = tA11y('ek_reg_legal_txt2');
  const subHeader2Content = tA11y('ek_reg_legal_hdl3');
  const subHeader2TextContent = tA11y('ek_reg_legal_txt3');
  const buttonContent = tA11y('ek_reg_legal_btn1');

  return (
    <>
      <ScrollToTop>
        <section className="pdf-download-container min-dvh-100">
          <AppPageContentWrapper>
            <NavigationPageTitle
              title={'ek_reg_legal_hdl1'}
              variant="lg"
              isBackButton
              onButtonClick={() => {
                setStep8SubStep(1);
                setShowActivationHeader(true);
              }}
            />
            {headerTextContent.content !== '' &&
              headerTextContent.content !== undefined &&
              (headerTextContent?.isHtml ? (
                <p
                  className="ek-copy-sm-14-regular text-primary pt-40"
                  dangerouslySetInnerHTML={{ __html: headerTextContent?.content }}
                />
              ) : (
                <p className="ek-copy-sm-14-regular text-primary pt-40">
                  {headerTextContent?.content}
                </p>
              ))}
            {subHeader1Content.content !== '' &&
              subHeader1Content.content !== undefined &&
              (subHeader1Content?.isHtml ? (
                <h2
                  className=".ek-h2 text-primary pt-40"
                  dangerouslySetInnerHTML={{ __html: subHeader1Content?.content }}
                />
              ) : (
                <h2 className=".ek-h2 text-primary pt-40">{subHeader1Content.content}</h2>
              ))}
            {/* <h2 className=".ek-h2 text-primary pt-40" 
                    dangerouslySetInnerHTML={{__html: "Nutzungsdaten, Endgeräte"}}
                /> */}

            {subHeader1TextContent.content !== '' &&
              subHeader1TextContent.content !== undefined &&
              (subHeader1TextContent?.isHtml ? (
                <p
                  className="ek-copy-sm-14-regular text-primary pt-1"
                  dangerouslySetInnerHTML={{ __html: subHeader1TextContent?.content }}
                />
              ) : (
                <p className="ek-copy-sm-14-regular text-primary pt-1">
                  {subHeader1TextContent?.content}
                </p>
              ))}
            {subHeader2Content.content !== '' &&
              subHeader2Content.content !== undefined &&
              (subHeader2Content?.isHtml ? (
                <h2
                  className=".ek-h2 text-primary pt-40"
                  dangerouslySetInnerHTML={{ __html: subHeader2Content?.content }}
                />
              ) : (
                <h2 className=".ek-h2 text-primary pt-40">{subHeader2Content?.content}</h2>
              ))}
            {subHeader2TextContent.content !== '' &&
              subHeader2TextContent.content !== undefined &&
              (subHeader2TextContent?.isHtml ? (
                <p
                  className="ek-copy-sm-14-regular text-primary pt-1"
                  dangerouslySetInnerHTML={{ __html: subHeader2TextContent?.content }}
                />
              ) : (
                <p className="ek-copy-sm-14-regular text-primary pt-1">
                  {subHeader2TextContent?.content}
                </p>
              ))}
            <div className="w-100 justify-content-center pt-40">
              <div className="col-lg-6 col-10 px-0 mx-auto">
                <ButtonPrimary
                  buttonType={appButtonType.SECONDARY}
                  iconLeft={appIconsPath.ARROW_BACK}
                  aria-label={tA11y('ek_global_icn-back_aria').ariaLabel}
                  buttonContent={buttonContent}
                  onClick={() => {
                    setStep8SubStep(1);
                    setShowActivationHeader(true);
                  }}
                />
              </div>
            </div>
          </AppPageContentWrapper>
        </section>
      </ScrollToTop>
    </>
  );
}

export default PDFDownload;
